import { render } from "./Levels.vue?vue&type=template&id=8b2ce4ee&scoped=true&ts=true"
import script from "./Levels.vue?vue&type=script&lang=ts"
export * from "./Levels.vue?vue&type=script&lang=ts"

import "./Levels.vue?vue&type=style&index=0&id=8b2ce4ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2ce4ee"]])

export default __exports__